import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { selectColor, Icon } from '@panel/commons';

const Wrapper = styled.form`
  position: relative;
`;

const UserInput = styled.input`
  outline: 0;
  border: 0;
  box-sizing: border-box;
  outline: none;
  height: 16px;
  padding: 20px 36px 20px 16px;
  color: ${selectColor('gray50')};
  border-radius: 4px;
  text-overflow: ellipsis;
  width: 100%;
  border: 1px solid ${selectColor('gray25')};
  &:focus {
    border-color: ${selectColor('primary')};
    & ~ div {
      path {
        fill: ${selectColor('primary')};
      }
    }
  }
`;

const SearchIconWrapper = styled.div`
  position: absolute;
  height: 40px;
  width: 40px;
  right: 0px;
  top: 0px;
  padding: 8px;
`;

const ResetButton = styled.div``;
const SearchButton = styled.div``;

function SearchBox(props) {
  const { handleSelectedFilter, onSearchBoxInputFocus, onSearchBoxInputBlur } = props;
  const { t } = useTranslation();
  const [inputText, setInputText] = useState('');

  const ref = useRef(null);

  const handleChange = e => {
    setInputText(e.target.value);
  };

  const handleReset = () => {
    setInputText('');
  };

  const handleSearch = e => {
    e.preventDefault();
    const tidyInputSearch = inputText.replace(/[^\wÀ-ú0-9']+/g, ' ').trim();
    if (tidyInputSearch) {
      handleSelectedFilter('searchCode', tidyInputSearch);
    }
    handleReset();
    ref.current.blur();
  };

  return (
    <Wrapper onSubmit={handleSearch}>
      <UserInput
        ref={ref}
        type='search'
        onChange={handleChange}
        onFocus={onSearchBoxInputFocus}
        onBlur={onSearchBoxInputBlur}
        placeholder={t('panel.filters.searchBox.placeHolder')}
        value={inputText}
        maxLength={128}
        data-panel='filters_searchBox'
      />
      <SearchIconWrapper>
        {inputText ? (
          <ResetButton onClick={handleReset}>
            <Icon name='cross' viewBox='0 0 16 16' />
          </ResetButton>
        ) : (
          <SearchButton>
            <Icon name='search' />
          </SearchButton>
        )}
      </SearchIconWrapper>
    </Wrapper>
  );
}

export default SearchBox;
